<script lang="ts">
	//Hooks
	import { onMount } from 'svelte';
	//Services
	import { format } from '../../../../services/i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	//Stores
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	//Helpers
	import {
		get_gen_2_component_channel_structure,
		getSettingUiComponent,
		real_id,
	} from '../../../../helpers/interface_helpers';
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	//Design system components
	import { Button, Radio, Text, toast } from '@Shelly/shelly-design-system';
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';

	export let device;

	const id = real_id(device.id);

	const inputOptions = ['momentary', 'detached']; //ToDo keys
	const _inputOptions = [
		$format('option_attached', { default: 'attached' }), //need to unify this momentary ot attached
		$format('option_detached', { default: 'detached' }),
	];
	$: settingsStore = getDeviceSettings(id);
	let settings = readDeviceSettings(id);
	$: settings = $settingsStore ?? settings;
	const plugUi = getSettingUiComponent(device);
	const channel = get_gen_2_component_channel_structure(device);
	let type = settings?.[plugUi].controls[channel].in_mode,
		loading = false,
		cache;

	onMount(() => {
		cache = type;
	});

	const setInputType = (value) => {
		type = value;
	};

	const sentRequest = async () => {
		if (JSON.stringify(cache) !== JSON.stringify(type)) {
			loading = true;

			let params = { config: { controls: { [channel]: { in_mode: type } } } };

			const res: SettingRequest = await gen2Request(device, `${plugUi}.SetConfig`, params);
			cache = type;
			onSettingsResponse(res, device);
			loading = false;
		}
	};
</script>

<Text styleType="body-small" class="mb-s"
	>{$format('input_type_desc', { default: 'Set input type' })}</Text
>

{#each inputOptions as option, index}
	<Radio
		size="m"
		selected={option}
		value={type}
		on:click={() => setInputType(option)}
		id="radio-s1s48cy">{_inputOptions[index]}</Radio
	>
{/each}

<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequest}
	>{$format('button_save')}</Button
>
